<ngx-select [allowClear]="false" [items]="items" optionValueField="value" optionTextField="name"
    [(ngModel)]="ruleSelected" placeholder="Tipo de regla" (select)="changeVariable($event)">

    <ng-template ngx-select-option-not-found let-input>
        "{{input}}" no encontrada
    </ng-template>

</ngx-select>
